export interface DiscountPolicyLine {
  quantity: number;
  unitPriceHt: number;
  /**
   * Ancre TTC de la ligne (prix catalogue). Quand elle est présente, une
   * remise en montant s'exprime en TTC (règle de calculateLineTotals) : le %
   * effectif se lit donc sur le brut TTC, pas sur le brut HT — sinon il est
   * surestimé du facteur de TVA et bloque des remises pourtant autorisées.
   */
  unitPriceTtc?: number | null;
  discountPct?: number | null;
  discountMode?: 'pct' | 'amount' | null;
  discountAmount?: number | null;
}

function clampPercent(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.min(100, Math.max(0, value));
}

/** Brut de la ligne du côté où s'exprime sa remise en montant. */
function grossOnAnchorSide(line: DiscountPolicyLine): number {
  const anchorTtc = Number(line.unitPriceTtc);
  const unit = Number.isFinite(anchorTtc) && anchorTtc > 0
    ? Math.round(anchorTtc * 1000) / 1000
    : Number(line.unitPriceHt);
  return Number(line.quantity) * unit;
}

export function effectiveLineDiscountPercent(line: DiscountPolicyLine): number {
  if (line.discountMode === 'amount') {
    const base = grossOnAnchorSide(line);
    return base > 0 ? clampPercent((Number(line.discountAmount ?? 0) / base) * 100) : 0;
  }
  return clampPercent(Number(line.discountPct ?? 0));
}

export function maxRequestedDiscountPercent(input: {
  documentTotalHt?: number | null;
  documentDiscount?: number | null;
  lines?: readonly DiscountPolicyLine[] | null;
}): number {
  const documentBase = Number(input.documentTotalHt ?? 0);
  const documentPercent = documentBase > 0
    ? clampPercent((Number(input.documentDiscount ?? 0) / documentBase) * 100)
    : 0;
  return Math.max(
    documentPercent,
    ...(input.lines ?? []).map(effectiveLineDiscountPercent),
  );
}
